import React from 'react'
import { Col, } from 'reactstrap'
import PropTypes from 'prop-types'
import ProgramContact from './ProgramContact'
import { arrayIsNullOrEmpty, sanitizeUrl, } from '../../util/helpers'

const HowToApplySection = React.forwardRef(({
  howToApplyContacts = [],
  programUrl = null,
  programDocumentUrl = null,
  applyInstructions = null,
  applyUrl = null,
  showHowToApply = false,
}, ref) => {
  const programWebsite = sanitizeUrl(programUrl)
  const applyWebsite = sanitizeUrl(applyUrl)
  const documentWebsite = sanitizeUrl(programDocumentUrl)
  const showContacts = (!arrayIsNullOrEmpty(howToApplyContacts))
  
  return <>
    {
      showHowToApply === true &&
      <Col xs={12}>
        <h3 className={'heading-3'} ref={ref}>How to Apply</h3>
        {
          applyInstructions && <>
            <h4 className={'heading-4'}>Instructions</h4>
            <p style={{ whiteSpace: 'pre-wrap', }}>{applyInstructions}</p>
          </>
        }
        { 
          applyWebsite && <a className={'btn btn-secondary'} target={'_blank'} rel={'noopener noreferrer'} href={applyWebsite}>View Application Info</a>
        }
      </Col>
    }
    {
      showContacts &&
        <Col xs={12}>
          <h4 className={'heading-4'}>To learn more please contact:</h4>
          {
            howToApplyContacts.reduce((prev, curr, idx) => {
              if (curr != null) {
                prev.push(<ProgramContact 
                  contactEmail={curr.email}
                  contactName={curr.name} 
                  contactTitle={curr.title} 
                  key={`apply-contact-${idx}`}
                />)
              }
              return prev              
            }, [])
          }
          
        </Col>
    }
    { 
      programWebsite && 
        <Col md={5} xs={12} className={'mt-4'}> 
          <a className={'btn btn-secondary'} target={'_blank'} rel={'noopener noreferrer'} href={programWebsite}>Visit Program Website</a>
        </Col>
    }
    { 
      documentWebsite &&
        <Col md={5} xs={12} className={'mt-4'}>
          <a className={'btn btn-secondary'} target={'_blank'} rel={'noopener noreferrer'} href={documentWebsite}>View Program Documentation</a>
        </Col>
    }
  </>
})

HowToApplySection.displayName = 'HowToApplySection'

HowToApplySection.propTypes = {
  howToApplyContacts: PropTypes.array,
  programUrl        : PropTypes.string,
  programDocumentUrl: PropTypes.string,
  applyInstructions : PropTypes.string,
  applyUrl          : PropTypes.string,
  showHowToApply    : PropTypes.bool,
}

export default HowToApplySection